import { ValidationRule } from 'app/infrastructure/simple-form';

export type SimpleFormValidationRule = (data: any, translation: (id: number) => string) => SimpleFormValidationError;

export type SimpleFormValidationConfig = SimpleFormValidationRule[];

export enum ValidationType {
  Required,
  Email,
  Equals,
  Unique
}

export interface SimpleFormValidationError {
  field: string;
  message: string;
}

export type SimpleFormValidation = (
  configurationObject: SimpleFormValidationConfig,
  onContinue?: (any: any) => void,
  errorMessage?: string
) => void;

export interface SimpleFormValidationProp {
  type: ValidationType;
  fields?: string | string[];
  rules?: ValidationRule[];
}
